export const INSPECTOR_ANALYTICS = {
  "INSPECTOR: Searched Term": ({ term }: { term: string }) => ({
    inspector_search_term: term,
  }),
};
